import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as api from './api';
import AuthModal from './AuthModal';

function RegisterPage({ onClose }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const firstInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await api.register(username, password);
      setSuccess('Registration successful! You can now log in.');
      setTimeout(() => {
        onClose();
        navigate('/welcome', { state: { showLogin: true } });
      }, 2000);
    } catch (err) {
      setError('Failed to register. Please try again.');
    }
  };

  return (
    <AuthModal title="Register" onClose={onClose} firstInputRef={firstInputRef} icon="person_add">
      <form onSubmit={handleSubmit} className="register-form">
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        <input
          ref={firstInputRef}
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button title="Register" type="submit">Register</button>
      </form>
    </AuthModal>
  );
}

export default RegisterPage;